<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_1"></a><a id="page_2"></a><span class="smallcaps">FOR TRISTAN JAMES</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?4e34c188